import { Injectable } from '@angular/core';
import { ConfigService } from 'core/config';
import { BehaviorSubject, filter } from 'rxjs';
import { SSLocalStorageService } from './local-storage';
import { LLanguage } from './types';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  readonly supportedLanguages = this._configService.appConfig.language.supportedLanguages;
  readonly selectedLanguageSubject = new BehaviorSubject<LLanguage>(undefined)
  readonly defaultLanguage = this._configService.appConfig.language.defaultLanguage;

  get selectedLanguage() {
    return this.selectedLanguageSubject.value
  }

  get #browserLanguage(): LLanguage {
    return window.navigator.language.includes('hr') ? 'hr' : 'en'
  }

  constructor(
    private readonly _configService: ConfigService,
    private readonly _localStorageService: SSLocalStorageService
  ) {

    this.selectedLanguageSubject.pipe(
      filter(Boolean)
    )
      .subscribe((language) => {
        this._localStorageService.set('language', language);
      })

    const defaultLanguage = this._localStorageService.get('language') || this.defaultLanguage || this.#browserLanguage;

    this._localStorageService.set('language', defaultLanguage)
    this.selectedLanguageSubject.next(defaultLanguage as LLanguage);

  }

}
